import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Tag, Popconfirm } from 'antd';
import './style.scss';
import { connect } from 'react-redux'
import { showModal, MODAL_ADD_STUDENT_ROOM } from '../../../modules/modals';
import { deleteRoomStudent, sendInvite } from '../actions';
import {toastr} from 'react-redux-toastr'
import {QuestionCircleOutlined, CloseOutlined} from '@ant-design/icons'

class Students extends Component {
  static contextTypes = {formatMessage: PropTypes.any}


  sendInvite = async (student_id) => {
    const {formatMessage} = this.context;
    const { room } = this.props;
    try {
      await sendInvite({student_id, room_id: room.id});
      toastr.success(formatMessage('titSuccessSendInviteStudentRoom'), formatMessage('msgSuccessSendInviteStudentRoom'))
    } catch (error) {
      toastr.error(formatMessage('titErrorSendInviteStudentRoom'), formatMessage('msgErrorSendInviteStudentRoom'))
    }
  }

  render() {
    const {formatMessage} = this.context;
    const { students, room } = this.props;
    
    const columns = [
      {
        title: formatMessage('tableStudentNumber'),
        dataIndex: 'number',
        key: 'number',
      },
      {
        title: formatMessage('tableStudentFirstName'),
        dataIndex: 'firstname',
        key: 'firstname',
      },
      {
        title: formatMessage('tableStudentLastName'),
        dataIndex: 'lastname',
        key: 'lastname',
      },
      {
        title: formatMessage('tableStudentEmail'),
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: formatMessage('tableStudentInvitationStatus'),
        key: 'is_done',
        dataIndex: 'is_done',
        render: status => 
          <Tag color={ status ? 'green' : 'volcano'}>
            {status ? 'Accepted' : 'Pending'}    
          </Tag>
        ,
      },
      {
        title: '',
        render: (item) => {
          return <div className="actions">
            {item.is_done == 0 ? <i onClick={() => {this.sendInvite(item.id)}} className="icon far fa-envelope"></i> : null}
            <Popconfirm
              title={formatMessage('msgDeleteStudentRoom')}
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={ async() => {
                const { room } = this.props;
                await this.props.deleteRoomStudent({
                  room_id: room.id,
                  student_id: item.id,
                });
                
              }}
            >
              <CloseOutlined />
            </Popconfirm>
          </div>
        },
        key: 'actions',
      },
    ];

    return (
      <div className="question-container Students">
        <div className="question-types-block">
          {room && <div className="btn-actions">
            <div className="question-type" onClick={() => {
              const { showModal } = this.props;
              showModal({
                modalType : MODAL_ADD_STUDENT_ROOM,
                modalProps : {
                }
              });
            }}>
              <span className="question-type-plus-icon">+</span> {formatMessage('btnAddStudentToClassRoom')}
            </div>
          </div>}
          <div className="table-data">
            {room && <Table dataSource={students.map((_i, index) => ({..._i, number: index +1}))} columns={columns} bordered pagination={false} />}
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  students: state.rooms.students,
  room: state.rooms.item,
})

const mapDispatchToProps = {
  showModal,
  deleteRoomStudent
}

export default connect(mapStateToProps, mapDispatchToProps)(Students)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/RoomsAndStudents/Students/index.jsx